export const handleNavigation = (path) => {
  window.location.href = path;
};